import * as yup from 'yup';

export const resetPasswordFormSchema = yup.object().shape({
  email: yup.string().email().trim().max(100).required(),
});
